export const queryKeys = {
  leaderboard: {
    all: ["leaderboard"] as const,
    categories: () => ["leaderboard", "categories"] as const,
    projectsRoot: () => ["leaderboard", "projects"] as const,
    projects: (
      params: {
        page?: number;
        sort?: string;
        direction?: string;
        filters?: unknown;
      } = {}
    ) => ["leaderboard", "projects", params] as const,
    project: (projectId: string) => ["leaderboard", "project", projectId] as const,
  },
  projectDetail: {
    detail: (projectId: string, context = "default") =>
      ["project-detail", projectId, context] as const,
  },
  evWorkstation: {
    projectsRoot: () => ["ev-workstation", "projects"] as const,
    projects: (
      params: {
        search?: string;
        stage?: string;
        owner?: string;
        priority?: string;
        scope?: string;
        scoreBand?: string;
        deltaDirection?: string;
      } = {}
    ) => ["ev-workstation", "projects", params] as const,
    project: (projectId: string) => ["ev-workstation", "project", projectId] as const,
    callPrep: (projectId: string) => ["ev-workstation", "call-prep", projectId] as const,
    callPrepStatus: (projectId: string) =>
      ["ev-workstation", "call-prep-status", projectId] as const,
    agentContext: (projectId: string) => ["ev-workstation", "agent-context", projectId] as const,
    googleStatus: () => ["ev-workstation", "google-status"] as const,
    telegramStatus: () => ["ev-workstation", "telegram-status"] as const,
    xStatus: () => ["ev-workstation", "x-status"] as const,
    xPromptSettings: () => ["ev-workstation", "x-prompt-settings"] as const,
    xThread: (relationshipId: string) => ["ev-workstation", "x-thread", relationshipId] as const,
    xAudit: (relationshipId: string) => ["ev-workstation", "x-audit", relationshipId] as const,
    xQueueContacts: (params: { search?: string; limit?: number } = {}) =>
      ["ev-workstation", "x-queue-contacts", params] as const,
    xQueueDrafts: (params: { status?: string } = {}) =>
      ["ev-workstation", "x-queue-drafts", params] as const,
    xQueueDraft: (draftId: string) => ["ev-workstation", "x-queue-draft", draftId] as const,
    contacts: (params: { search?: string; ownerScope?: string; limit?: number } = {}) =>
      ["ev-workstation", "contacts", params] as const,
    contactsRoot: () => ["ev-workstation", "contacts"] as const,
    followUps: () => ["ev-workstation", "follow-ups"] as const,
    summary: () => ["ev-workstation", "summary"] as const,
    brief: () => ["ev-workstation", "brief"] as const,
    owners: () => ["ev-workstation", "owners"] as const,
  },
  communityAnalysis: {
    projects: (search = "") => ["community-analysis", "projects", search] as const,
    activeJobs: () => ["community-analysis", "active-jobs"] as const,
  },
  trends: {
    summary: () => ["trends", "summary"] as const,
    dashboard: (period: number) => ["trends", "dashboard", period] as const,
  },
  apiStatus: {
    summary: () => ["api-status", "summary"] as const,
  },
  discovery: {
    status: () => ["discovery", "status"] as const,
  },
  auditLog: {
    list: (params: Record<string, unknown> = {}) => ["audit-log", "list", params] as const,
  },
  intelligence: {
    kpis: () => ["intelligence", "kpis"] as const,
    categoryMatrix: () => ["intelligence", "category-matrix"] as const,
    scatter: () => ["intelligence", "scatter"] as const,
    backerLeague: (limit: number) => ["intelligence", "backer-league", limit] as const,
    backerSpecialization: (limit: number) =>
      ["intelligence", "backer-specialization", limit] as const,
    coInvestors: (projectId: string, minShared: number) =>
      ["intelligence", "co-investors", projectId, minShared] as const,
    runwayStress: (limit: number) => ["intelligence", "runway-stress", limit] as const,
    stealthWatchlist: (limit: number) => ["intelligence", "stealth-watchlist", limit] as const,
    founderPedigree: () => ["intelligence", "founder-pedigree"] as const,
    ecosystemSnapshot: (minSample: number) =>
      ["intelligence", "ecosystem-snapshot", minSample] as const,
    stageMix: () => ["intelligence", "stage-mix"] as const,
  },
};
